// Generic Portal Studio tab helpers, shared by the supplier and operator
// inspector rails. Each surface owns its own tab model (which settings live in
// which tab); this module only holds the surface-agnostic error-routing rule so
// both inspectors route an invalid submit the same way.
//
// A tab model is `[{ id, label, icon, fields }]`. `fields` lists the react-hook-
// form field names that tab owns; the field→tab map deliberately duplicates
// knowledge the zod schema also holds — which tab a field belongs to is a UI
// grouping decision, not a validation one. Each surface's exhaustiveness test
// keeps the two from drifting.

// An error on an unmapped field falls back to the first tab rather than
// rendering no tab at all.
export const firstTabWithError = (tabs, errors = {}) =>
  (tabs.find((tab) => tab.fields.some((field) => errors[field])) || tabs[0]).id;
